<template>
  <div class="data_body">
    <div style="width: 100%; height: 100%;overflow: auto;">
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#E0EAFB',color: '#000' }"
        :row-class-name="tableRowClassName" class="tableClass">
        <el-table-column label="序号" min-width="30" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="username" label="教师姓名" min-width="100" align="center">
        </el-table-column>
        <el-table-column prop="worksCount" label="教师提交次数" min-width="90" align="center">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    workList: {
      type: Array,
    },
  },
  data() {
    return {
      tableData: [

      ],
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "even_row";
      } else {
        return "";
      }
    },
    setArray(array){
      this.tableData = array
      // for(var i = 0;i<array.length;i++){
      //   this.tableData.push({
      //     sum:array[i].course,
      //     name:array[i].name
      //   })
      // }
      // this.tableData = this.tableData.sort(function(a,b){
      //   return b.sum - a.sum;
      // })
    }
  },
  watch: {
    workList: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setArray(newValue)
        this.$forceUpdate();
      },
    },
  },
  mounted() {
    this.setArray(this.workList)
  },
};
</script>

<style scoped>
.el-table>>>.even_row {
  background-color: #f2f7ff !important;
}

.data_body {
  height: 100%;
  /* display: flex; */
  position: relative;
  border-radius: 5px;
  /* border: 1px solid #eee; */
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0;
  width: 95%;
  background: #fff;
}

.tableClass >>> td, .tableClass >>> th{
  padding: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/dataBoardTest/course/chartList/bar.vue